import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { usersService, UsersQueryParams } from '@/services/usersService'

export interface UseUserListParams extends UsersQueryParams {}

export function useUserList(params: UseUserListParams) {
  const queryParams = useMemo(() => {
    const sanitized: UsersQueryParams = {
      page: params.page ?? 1,
      perPage: params.perPage ?? 10,
    }

    if (params.search) {
      sanitized.search = params.search.trim()
    }

    if (params.role) {
      sanitized.role = params.role
    }

    if (typeof params.isActive === 'boolean') {
      sanitized.isActive = params.isActive
    }

    return sanitized
  }, [params.page, params.perPage, params.search, params.role, params.isActive])

  return useQuery({
    queryKey: [
      'users',
      'list',
      queryParams.page,
      queryParams.perPage,
      queryParams.search ?? '',
      queryParams.role ?? '',
      typeof queryParams.isActive === 'boolean' ? String(queryParams.isActive) : 'all',
    ],
    queryFn: () => usersService.getUsersPage(queryParams),
    placeholderData: (previousData) => previousData,
    staleTime: 60 * 1000,
  })
}
